import React, {Component} from 'react'
import {Collapse, Button} from 'reactstrap'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'
import {Mutation} from 'react-apollo'
import {toast} from 'react-toastify'

import upsertClientContactsMutation from '../../../queries/server/mutations/upsert_client_contacts'
import editClientLocalMutation from '../../../queries/client_side/mutations/edit_client'

import ClientContactsList from "./ClientContactsList";
import ClientContactForm from "./ClientContactForm";
import ClientContactInput from "./ClientContactInput";


class ClientContacts extends Component {

    state = {
        showInput: false,
        newContact: {
            first_name: '',
            last_name: '',
            position: ''
        }
    }

    newContactChanged = ({key, value}) => {
        const newData = {}
        newData[key] = value
        this.setState({newContact: {...this.state.newContact, ...newData}})
    }

    render() {

        const {client_id, contacts} = this.props
        const {showInput, newContact} = this.state

        return (
            <div>
                <Button
                    size="sm"
                    color={showInput ? 'warning' : 'success'}
                    onClick={() => this.setState({showInput: !showInput})}
                >
                    <FontAwesomeIcon color="#fff" icon={showInput ? 'minus' : 'plus'}/>{' '}
                    {showInput ? 'Cancel' : 'Add Contact'}
                </Button>

                <Collapse isOpen={showInput}>
                    <Mutation mutation={upsertClientContactsMutation}>
                        {(upsertClientContactsMutationFunc, {loading}) => (
                            <Mutation mutation={editClientLocalMutation}>
                                {(editClientLocalMutationFunc) => (
                                    <div className="d-flex flex-column pt-3 mt-3 card card-body bg-light">
                                        <ClientContactInput
                                            onSave={() => {
                                                upsertClientContactsMutationFunc({
                                                    variables: {
                                                        client_id,
                                                        data: [{...newContact}]
                                                    }
                                                })
                                                    .then(({data}) => {
                                                        editClientLocalMutationFunc({variables: {data: data.upsertClientContact}})
                                                        toast.success('Client Contact Added', {autoClose: 2000})
                                                        this.setState({showInput: false})
                                                    })
                                                    .catch(e => toast.error(e.message, {autoClose: false}))
                                            }}
                                            onCancel={() => this.setState({showInput: false})}
                                            onChange={this.newContactChanged}
                                            loading={loading}
                                            {...newContact}
                                        />
                                    </div>
                                )}
                            </Mutation>
                        )}

                    </Mutation>
                </Collapse>

                <ClientContactsList
                    client_id={client_id}
                    contacts={contacts}
                />
            </div>
        )
    }

}

ClientContacts.propTypes = {
    client_id: PropTypes.number.isRequired,
    contacts: PropTypes.array
}

export default ClientContacts